export default __webpack_public_path__ + "static/media/Vmware.90e18e31.svg";